/* product-purchase-actions.js  */
$(document).ready(function () {
    if (window.Shopify && window.Shopify.designMode) return;
    const PPA_NS = "ppa";
    
    function initPPA() {
        $(".ppa-wrapper:not([data-init])").each(function () {
            const $wrapper = $(this);
            const isModal = !!$wrapper.closest("quick-add-modal, modal-dialog, [data-modal-content], .modal").length;
            $wrapper.attr("data-init", "1").data("isModal", isModal);
            
            $wrapper.off(`click.${PPA_NS}`).on(`click.${PPA_NS}`, ".ppa-qty-btn", function (e) {
                e.preventDefault();
                const $input = $wrapper.find(".ppa-qty-field");
                const action = $(this).data("action");
                const current = parseInt($input.val()) || 1;
                const min = parseInt($input.attr("min")) || 1;
                const max = parseInt($input.attr("max")) || 999;
                let newVal = current;
                
                if (action === "plus" && current < max) newVal = current + 1;
                if (action === "minus" && current > min) newVal = current - 1;
                
                if (newVal !== current) {
                    $input.val(newVal).trigger("change");
                    $wrapper.find('[data-action="minus"]').prop("disabled", newVal <= min);
                    $wrapper.find('[data-action="plus"]').prop("disabled", newVal >= max);
                }
            });
            
            $wrapper.off(`click.${PPA_NS}-cart`).on(`click.${PPA_NS}-cart`, ".ppa-cart-btn", function (e) {
                e.preventDefault();
                const $btn = $(this);
                const variantId = getVariantId($wrapper);
                const quantity = parseInt($wrapper.find(".ppa-qty-field").val()) || 1;
                
                if (!variantId) return showError($btn, "Please select a variant");
                
                setLoading($btn, true);
                
                // Create FormData for Dawn theme compatibility
                let formData = new FormData();
                formData.append('items[][id]', parseInt(variantId));
                formData.append('items[][quantity]', quantity);
                
                // Get cart drawer/notification element for sections
                const cartObject = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
                if (cartObject && typeof cartObject.getSectionsToRender === 'function') {
                    formData.append(
                        'sections',
                        cartObject.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                }
                
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    Promise.all([
                        updateCartBubble(), 
                        showProductNotification(data.items[0]),
                        openCartDrawer(data) // Add cart drawer functionality
                    ]).then(() => {
                        showSuccess($btn);
                        if (isModal) setTimeout(() => closeModal($wrapper), 1500);
                    });
                })
                .catch(error => {
                    let errorMsg = "Error adding to cart";
                    if (error.responseJSON) {
                        errorMsg = error.responseJSON.description || error.responseJSON.message || errorMsg;
                    }
                    showError($btn, errorMsg);
                })
                .finally(() => {
                    setLoading($btn, false);
                });
            });
            
            $wrapper.off(`click.${PPA_NS}-buy`).on(`click.${PPA_NS}-buy`, ".ppa-buy-btn", function (e) {
                e.preventDefault();
                if (sessionStorage.getItem("ppa-buy-now")) return;
                
                const variantId = getVariantId($wrapper);
                const quantity = parseInt($wrapper.find(".ppa-qty-field").val()) || 1;
                
                if (!variantId) return showError($(this), "Please select a variant");
                
                setLoading($(this), true);
                sessionStorage.setItem("ppa-buy-now", "1");
                setTimeout(() => (location.href = `/cart/${variantId}:${quantity}`), 500);
            });
        });
    }
    
    // New function to handle cart drawer opening
    async function openCartDrawer(cartData) {
        try {
            // Get the cart drawer element (Dawn theme)
            const cartDrawer = document.querySelector('cart-drawer');
            const cartNotification = document.querySelector('cart-notification');
            const cartObject = cartDrawer || cartNotification;
            
            if (cartObject) {
                // Remove empty state
                cartObject.classList.remove('is-empty');
                
                // Update cart contents if renderContents method exists
                if (typeof cartObject.renderContents === 'function') {
                    cartObject.renderContents(cartData);
                }
                
                // Open the drawer if it has an open method
                if (typeof cartObject.open === 'function') {
                    cartObject.open();
                }
                
                // Alternative: trigger the drawer by clicking cart icon if drawer doesn't open
                if (cartDrawer && !cartDrawer.classList.contains('active')) {
                    const cartIcon = document.querySelector('.header__icon--cart, [data-cart-drawer], .cart-icon');
                    if (cartIcon) {
                        setTimeout(() => cartIcon.click(), 100);
                    }
                }
                
                // For cart notification, ensure it's visible
                if (cartNotification && typeof cartNotification.open === 'function') {
                    cartNotification.open();
                }
            }
            
            // Alternative method: dispatch custom event for Dawn theme
            document.dispatchEvent(new CustomEvent('cart:open', { 
                detail: { cartData } 
            }));
            
        } catch (error) {
            console.log("Cart drawer open error:", error);
            
            // Fallback: try clicking the cart icon
            const cartIcon = document.querySelector('.header__icon--cart, [data-cart-drawer], .cart-icon');
            if (cartIcon) {
                setTimeout(() => cartIcon.click(), 100);
            }
        }
    }
    
    function getVariantId($wrapper) {
        const isModal = $wrapper.data("isModal");
        const $context = isModal ? $wrapper.closest("quick-add-modal, modal-dialog, [data-modal-content], .modal") : $(document);
        let variantId = null;
        
        const $selectedSwatch = $context.find('.color-swatch.selected, .variant-swatch.selected, [aria-current="true"], .swatch-element.selected');
        if ($selectedSwatch.length) {
            variantId = $selectedSwatch.data("variant-id") || $selectedSwatch.data("value");
        }
        
        if (!variantId) {
            const $input = $context.find('input[name="id"], select[name="id"]');
            if ($input.length && $input.val()) {
                variantId = $input.val();
            }
        }
        
        if (!variantId) {
            const $radio = $context.find('input[type="radio"]:checked');
            if ($radio.length) {
                variantId = $radio.data("variant-id") || $radio.val();
            }
        }
        
        if (!variantId) {
            variantId = $wrapper.find(".ppa-cart-btn").data("variant-id");
        }
        
        console.log("Variant ID found:", variantId);
        return variantId;
    }
    
    async function showProductNotification(addedItem) {
        try {
            const notificationHTML = `<div class="cart-notification-product"><div class="cart-notification-product__image"><img src="${addedItem.image}" alt="${addedItem.product_title}" width="70" height="70"></div><div class="cart-notification-product__info"><h3 class="cart-notification-product__name h4">${addedItem.product_title}</h3>${addedItem.variant_title ? `<p class="cart-notification-product__variant">${addedItem.variant_title}</p>` : ""}</div></div>`;
            
            $("#cart-notification-product").html(notificationHTML);
            
            const $notification = $("cart-notification");
            if ($notification.length) {
                if ($notification[0].cartItemKey) $notification[0].cartItemKey = addedItem.key;
                if (typeof $notification[0].open === "function") {
                    $notification[0].open();
                } else {
                    $("#cart-notification").addClass("animate active").focus();
                }
            }
        } catch (error) {
            $("#cart-notification").addClass("animate active").focus();
        }
    }
    
    async function updateCartBubble() {
        try {
            const cartData = await $.get("/cart.js");
            $('.cart-count-bubble span[aria-hidden="true"]').text(cartData.item_count);
            $(".cart-count-bubble").toggle(cartData.item_count > 0);
            
            try {
                const iconResponse = await $.get(`${location.pathname}?sections=cart-icon-bubble`);
                $("#cart-icon-bubble").html(iconResponse["cart-icon-bubble"]);
            } catch (iconError) {
                console.log("Cart icon update failed:", iconError);
            }
        } catch (error) {
            console.error("Cart update error:", error);
        }
    }
    
    function setLoading($btn, loading) {
        $btn.toggleClass("loading", loading).prop("disabled", loading);
        $btn.find(".ppa-loader").toggle(loading);
    }
    
    function showSuccess($btn) {
        const $label = $btn.find(".ppa-cart-label, .ppa-buy-text");
        const original = $label.text();
        $label.text("Added!").css("color", "#000");
        setTimeout(() => $label.text(original).css("color", ""), 2000);
    }
    
    function showError($btn, message) {
        const $label = $btn.find(".ppa-cart-label, .ppa-buy-text");
        const original = $label.text();
        $label.text(message).css("color", "#f00");
        setTimeout(() => $label.text(original).css("color", ""), 3000);
    }
    
    function closeModal($wrapper) {
        const $modal = $wrapper.closest("quick-add-modal, modal-dialog, .modal, [data-modal-content]");
        if ($modal.length) {
            const modal = $modal[0];
            if (typeof modal.hide === "function") modal.hide();
            else if (typeof modal.close === "function") modal.close();
            else $modal.removeClass("active").removeAttr("open");
            $modal.trigger("modal:close");
        }
    }
    
    initPPA();
    $(document).on("product-info:loaded modal:opened", () => setTimeout(initPPA, 150));
    
    $(document).on("change click", '.single-option-selector, select[name="id"], .color-swatch, .variant-swatch', function () {
        const variantId = $(this).val() || $(this).data("variant-id");
        if (variantId) {
            const $context = $(this).closest("[data-modal-content], .modal") || $(document);
            const $hiddenInput = $context.find('input[name="id"]');
            if ($hiddenInput.length) {
                $hiddenInput.val(variantId).attr("value", variantId);
            } else {
                $context.find('form[action*="/cart/add"]').append(`<input type="hidden" name="id" value="${variantId}">`);
            }
            $(".ppa-cart-btn, .ppa-buy-btn").attr("data-variant-id", variantId);
            $(document).trigger("variant:change", { variant: { id: variantId } });
        }
    });
    
    $(window).on("pageshow visibilitychange focus", function () {
        if (!document.hidden) {
            $(".ppa-cart-btn, .ppa-buy-btn").removeClass("loading").prop("disabled", false);
            $(".ppa-loader").hide();
            sessionStorage.removeItem("ppa-buy-now");
        }
    });
});
